// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ead3e4b6","229":"03fe3d80","438":"cac4e0ca","444":"455fd5e6","453":"1f722c5f","547":"d8e3bfa1","579":"6792a98f","627":"937b67d9","715":"e2316816"}[chunkId] + ".chunk.js";
};